/**
 * 作为 micro-app 子应用时，必须把 webpack 动态 chunk 指到 doctor 自己的域名。
 * 否则生产环境 publicPath 是 "/"，懒加载页面会去 portal 域名拉 js，模块为 undefined。
 */
if ((window as any).__MICRO_APP_ENVIRONMENT__) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  __webpack_public_path__ = (window as any).__MICRO_APP_PUBLIC_PATH__;
}
